import React from 'react'

const AcceptedStatus = ({
  firstColor = '#F1F2FF',
  color = '#4E60FF',
}: {
  firstColor?: string
  color?: string
}) => {
  return (
    <svg
      width='85'
      height='90'
      viewBox='0 0 85 90'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.93762 59.2824C2.93762 70.6279 7.87802 80.8194 15.7249 87.8232H66.6374C74.4843 80.8194 79.4247 70.6279 79.4247 59.2824H2.93762Z'
        fill={firstColor}
      />
      <path
        d='M79.4247 48.382C79.4247 40.5899 73.1079 34.2731 65.3157 34.2731C61.882 34.2731 58.7348 35.4997 56.2883 37.5386C54.723 36.234 52.8708 35.262 50.8402 34.7311C49.3993 28.4685 43.7902 23.7985 37.0902 23.7985C31.8178 23.7985 27.2209 26.6904 24.7992 30.9745C23.0395 30.186 21.0887 29.7474 19.0355 29.7474C11.2433 29.7474 4.92651 36.0642 4.92651 43.8564M24.2577 46.4011C29.2047 41.4541 37.2253 41.4541 42.1723 46.4011M55.894 21.1962L60.448 2.16235M69.9649 23.7985L82.0469 6.79069M15.7249 87.8232C7.87802 80.8194 2.93762 70.6279 2.93762 59.2824H79.4247C79.4247 70.6279 74.4843 80.8194 66.6374 87.8232H15.7249Z'
        stroke={color}
        strokeWidth='4'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default AcceptedStatus
